import { render } from "./ImgSwiper.vue?vue&type=template&id=58af7d84&scoped=true"
import script from "./ImgSwiper.vue?vue&type=script&lang=js"
export * from "./ImgSwiper.vue?vue&type=script&lang=js"

import "./ImgSwiper.vue?vue&type=style&index=0&id=58af7d84&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58af7d84"]])

export default __exports__